import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const createNotice = async (data) => {
  const response = await axiosInstance.post("/notices/create", data);
  return response.data;
};

export const getAllNotices = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.category) params.append("category", filters.category);
  if (filters.isActive !== undefined && filters.isActive !== "") params.append("isActive", filters.isActive);
  if (filters.targetAudience) params.append("targetAudience", filters.targetAudience);

  const response = await axiosInstance.get(`/notices/all?${params.toString()}`);
  return response.data;
};

export const getNoticeById = async (id) => {
  const response = await axiosInstance.get(`/notices/${id}`);
  return response.data;
};

export const updateNotice = async (id, data) => {
  const response = await axiosInstance.put(`/notices/update/${id}`, data);
  return response.data;
};

export const pinNotice = async (id) => {
  const response = await axiosInstance.put(`/notices/pin/${id}`);
  return response.data;
};

export const deleteNotice = async (id) => {
  const response = await axiosInstance.delete(`/notices/delete/${id}`);
  return response.data;
};